<template>
    <div class="components-container" id="mobileViewPort">
        <div id="mobileMode">
            <div id="titleArea">
                <div class="titleText">成绩查询</div>
                <div class="titleButton">
                    <el-button class="custom-el-button" type="primary" @click="showHomePage">
                        <i class="el-icon-s-home"></i> 首页
                    </el-button>
                </div>
            </div>
            <div id="queryArea">
                <div class="filter-container">
                    <div class="formItem">
                        <el-select v-model="queryForm.semesterCode" placeholder="学年学期" style="width:100%;" clearable>
                            <el-option v-for="(item, index) in comboOption.semester" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="formItem text-center">
                        <el-button @click="handleFilter" type="gray"><i class="el-icon-search"></i> 查询</el-button>
                        <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i> 重置</el-button>
                        <el-button @click="queryDialogVisible = true" type="primary"><i class="el-icon-more"></i> 更多</el-button>
                    </div>
                </div>
            </div>
            <!-- 搜索内容弹框 -->
            <el-dialog id="queryDialog" class="formDialog" title="查询信息" width="90%" :visible.sync="queryDialogVisible">
                <el-row>
                    <el-select v-model="queryForm.semesterCode" placeholder="学年学期" clearable>
                        <el-option v-for="(item, index) in comboOption.semester" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                        </el-option>
                    </el-select>
                </el-row>
                <el-row>
                    <el-select v-model="queryForm.courseType" placeholder="课程类型" clearable>
                        <el-option v-for="(item, index) in comboOption.courseType" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                        </el-option>
                    </el-select>
                </el-row>
                <el-row>
                    <el-input v-model="queryForm.courseName" placeholder="课程名称"></el-input>
                </el-row>
                <div slot="footer" class="dialog-footer text-center">
                    <el-button type="gray" @click="handleFilter">查 询</el-button>
                    <el-button style="margin-left: 10px;" type="gray" @click="handleReset">重 置</el-button>
                    <el-button style="margin-left: 10px;" @click="queryDialogVisible = false">取 消</el-button>
                </div>
            </el-dialog>

            <div id="listArea">
                <el-table :data="tableData" @current-change="handleCurrentChange" v-loading.body="tableLoading" :cell-style="handleCellStyle"
                    element-loading-text="信息加载中" stripe border fit highlight-current-row
                    :height="mainTableHeight" ref="mainTable">
                    <el-table-column label="学年学期" prop="semesterCode" fixed width="60px" align="center"></el-table-column>
                    <el-table-column :label="'课程\n名称'" prop="courseName" fixed width="80" align="center"></el-table-column>
                    <el-table-column label="平时" prop="ususlScore" width="45px" align="center"></el-table-column>
                    <el-table-column label="期中" prop="midScore" width="45px" align="center"></el-table-column>
                    <el-table-column label="实训" prop="trainingScore" width="45px" align="center"></el-table-column>
                    <el-table-column label="期末" prop="finalScore" width="45px" align="center"></el-table-column>
                    <el-table-column label="总评" prop="totalScore" width="45px" align="center"></el-table-column>
                    <el-table-column label="补考" prop="resitScore" width="45px" align="center"></el-table-column>
                    <el-table-column label="重修" prop="retakeScore" width="45px" align="center"></el-table-column>
                    <el-table-column label="大补考" prop="finalResitScore" width="45px" align="center"></el-table-column>
                    <el-table-column label="课程类型" prop="courseTypeName" width="100px" align="center"></el-table-column>
                </el-table>

                <!-- 分页区域 -->
                <div class="pagination-container">
                    <div style="width:100%; font-size:14px; color:#606266; text-align:center;">共&nbsp;{{ total }}&nbsp;条</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { confirmMsg, showNotify } from "utils/message";

    export default {
        data() {
            return {
                queryForm: {
                    pageNum: 1,
                    rowNum: 100,
                    semesterCode: null,
                    courseType: null,
                    courseName: null,
                },
                queryDialogVisible: false,
                comboOption: {
                   semester: null,
                   courseType: null,
                },
                tableData: [],
                total: null,
                tableLoading: true,
                mainTableHeight: 500,
            }
        },
        mounted() {
            this.initCombo();
            this.queryList();

            this.$nextTick().then(() => {
                //this.$refs.table.$el.offsetTop：表格距离浏览器的高度
                //最后数字表示要调整的表格距离底部的高度（如预留分页组件的高度）
                this.mainTableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 50;
                // 监听窗口大小变化
                let self = this;
                window.onresize = function() {
                    self.mainTableHeight = window.innerHeight - self.$refs.mainTable.$el.offsetTop - 50;
                };
            });
        },
        methods: {
            showHomePage(){
                this.$router.push('/m/wx/home');
            },
            //获取下拉列表数据
            initCombo() {
                this.$api.scoreManage.stuPersonalScore.initCombo({}).then((res) => {
                    this.comboOption.semester = res.data.data.semesterComboData;
                    this.comboOption.courseType = res.data.data.courseTypeComboData;
                }).catch((error) => {
                    showNotify('错误', error, 'error', 3000);
                });
            },
            queryList() {
                this.tableLoading = true;
                this.$api.scoreManage.stuPersonalScore.list({
                    data: this.queryForm,
                }).then((res) => {
                    this.total = res.data.data.total;
                    this.tableData = res.data.data.list;
                    this.tableLoading = false;
                }).catch((error) => {
                    this.tableLoading = false;
                    showNotify('错误', error, 'error', 3000);
                });
            },
            handleCellStyle({row, column, rowIndex, columnIndex}){
                let cellStyle;

                if(column.label.startsWith('平时')) return this.getScoreStyle(row.usualScore, row.passStandardScore);
                if(column.label.startsWith('期中')) return this.getScoreStyle(row.midScore, row.passStandardScore);
                if(column.label.startsWith('实训')) return this.getScoreStyle(row.trainingScore, row.passStandardScore);
                if(column.label.startsWith('期末')) return this.getScoreStyle(row.finalScore, row.passStandardScore);
                if(column.label.startsWith('总评')) return this.getScoreStyle(row.totalScore, row.passStandardScore);              
                if(column.label.startsWith('重修')) return this.getScoreStyle(row.retakeScore, row.passStandardScore);
                if(column.label.startsWith('补考')) return this.getScoreStyle(row.resitScore, row.passStandardScore);
                if(column.label.startsWith('大补考')) return this.getScoreStyle(row.finalResitScore, row.passStandardScore);
            },
            getScoreStyle(score, passStandardScore){
                let cellStyle = '';

                if((score!=='' && parseFloat(score)>-1 && parseFloat(score)<parseInt(passStandardScore,10))
                    || score==='作弊' || score==='取消资格' || score==='缺考' || score==='不及格' || score==='差' || score==='不合格'){
                    cellStyle = 'color: #FE2E2E !important;';
                }

                return cellStyle;
            },
            handleReset() {
                this.queryForm.pageNum = 1;
                this.queryForm.rowNum = 100;
                this.queryForm.semesterCode = null;
                this.queryForm.courseType = null;
                this.queryForm.courseName = null;
                this.queryList();
            },
            //页码区域方法
            handleCurrentChange(val, old) {
            },
            handleSizeChange(val) {
                this.queryForm.rowNum = val;
                this.queryForm.pageNum = 1;
                this.queryList();
            },
            handleFilter() {
                this.queryForm.pageNum = 1;
                this.queryList();
                this.queryDialogVisible = false;
            },
            handlePageChange(val) {
                this.queryForm.pageNum = val;
                this.queryList();
                 this.queryDialogVisible = false;
            },
        }
    };
</script>
<style src="styles/mobile.css"></style>
<style scoped>
    #mobileMode {
        line-height: 0;
    }

    #mobileMode #queryDialog {
        top: 150px;
    }

    #mobileMode #mainDialogScroll {
        height: 65vh;
        padding: 10px 20px;
    }

    #mobileMode #loadingTips {
        height: 30px;
        line-height: 30px;
        color: #9d9d9d;
        position: relative;
        bottom: 0;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// stuPersonalScore.vue?e3c915a6